import { GET, POST } from '../apiController';

const AUTH_BASE = "/org/auth";

// -------------------------------------------------
// Authentication APIs (used by frontend)
// Paths match backend auth routes (kebab-case).

/** @param {{ organization_url: string }} params */
export function getOrganizationBrandingApi(params) {
  return GET(`${AUTH_BASE}/organization-branding`, params);
}

export function getRegistrationCourseCategoriesApi(params) {
  return GET(`${AUTH_BASE}/course-categories`, params);
}

export function loginApi(data) {
  return POST(`${AUTH_BASE}/login`, data);
}

export function verifyLogin2FAApi(data) {
  return POST(`${AUTH_BASE}/verify-login-2fa`, data);
}

export function logoutApi() {
  return GET(`${AUTH_BASE}/logout`);
}

export function forgotPasswordApi(data) {
  return POST(`${AUTH_BASE}/forgot-password`, data);
}

export function verifyRegisterOTPApi(data) {
  return POST(`${AUTH_BASE}/verify-register-otp`, data);
}

export function resetPasswordApi(data) {
  return POST(`${AUTH_BASE}/reset-password`, data);
}

export function verifyOTPApi(data) {
  return POST(`${AUTH_BASE}/verify-otp`, data);
}

export function sendOTPApi(data) {
  return POST(`${AUTH_BASE}/forgot-password`, data);
}

export function newRegistrationApi(data) {
  return POST(`${AUTH_BASE}/new-registration`, data);
}

export function resendOTPApi(data) {
  return POST(`${AUTH_BASE}/send-otp`, data);
}

export function sendActiveAccountOtpFromLoginApi(data) {
  return POST(`${AUTH_BASE}/active-account-otp-from-login`, data);
}
